import React from "react";
import {
  Box,
  Typography,
  Grid,
  Link,
  useTheme,
  CssBaseline,
} from "@mui/material";
import { StandardPageHead } from "../components/Heads/StandardPageHead.tsx";
import { fetchAllVenues } from "../helpers/onCallFunctions.ts";
import { VenueNameAndSlug } from "../types/dataTypes.ts";
import { LoadingElementInBox } from "../components/Loading/LoadingElement.tsx";

export const AllCinemasPage: React.FC = () => {
  const theme = useTheme();
  const [venues, setVenues] = React.useState<VenueNameAndSlug[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const load = async () => {
      const data = await fetchAllVenues();
      setVenues(data);
      setIsLoading(false);
    };
    load();
  }, []);

  if (isLoading) return <LoadingElementInBox />;

  return (
    <>
      <CssBaseline />
      <StandardPageHead
        title="CinemaGuide Cinemas Page"
        description="A list of every cinema available on CinemaGuide, a platform for movie showtimes and cinema listings in Ireland."
        pageUrl="https://cinemaguideireland.com/cinemas"
      />
      <Typography
        variant="h1"
        component="h1"
        gutterBottom
        sx={{
          marginLeft: { xs: 0.5, md: 2 },
          marginRight: { xs: 0.5, md: 2 },
          paddingTop: { xs: 1, md: 1 },
          marginTop: 6,
          mb: 6,
          fontSize: { xs: "1.5rem", md: "2rem" },
          fontWeight: 500,
          textDecoration: "underline",
          maxWidth: "100%",
          textAlign: "center",
        }}
      >
        {`All Cinemas on CinemaGuide`}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          width: { md: "80%", xs: "95%" },
          mt: { xs: 4, md: 6 },
        }}
      >
        <Grid container spacing={{ xs: 1.5, sm: 2, md: 4 }}>
          {venues.map(({ venue_name, venue_slug }) => (
            <Grid
              key={venue_slug}
              item
              xs={6}
              sm={4}
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Link
                component="a"
                color={theme.palette.primary.main}
                sx={{
                  mb: 2,
                  fontSize: { xs: "large", md: "x-large" },
                  "&:hover": { cursor: "pointer" },
                  textShadow: "0 0 4px rgba(0,160,255,.4)",
                }}
                href={`cinemas/${venue_slug}`}
              >
                {venue_name}
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};
